import React, { Component, Fragment } from 'react'
import { Container,Row, Col, Card, Button } from 'react-bootstrap'
import hall1D from '../../asset/image/kk.jpg';
import hall2D from '../../asset/image/hall2.jpg';
import hall3D from '../../asset/image/hall3.jpg';
import { Link } from 'react-router-dom';

export class AllProjects extends Component {
  render() {
    return (
         <Fragment>
     
        <Container fluid={true} className='text-center projectBackPic'>
        
           <h1 className='h1Tag'>Upcoming Events</h1>
              <div className='bottom'></div>
         
      
            <Row>
                <Col lg={4} md={6} sm={12}>
                <Card className='projectCard'>
      <Card.Img variant="top" src={hall1D} height='10%'/>
      <Card.Body>
        <Card.Title className='h2Tag'>Markham Eid Bazaar</Card.Title>
        <Card.Text className='pTag'>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button variant="primary"><Link className='linkStyle' to="/projectdetails"> View More </Link></Button>
      </Card.Body>
    </Card>
                </Col>
                <Col lg={4} md={6} sm={12}>
                    <Card className='projectCard'>
      <Card.Img variant="top" src={hall2D} />
      <Card.Body>
        <Card.Title className='h2Tag'>Project 2</Card.Title>
        <Card.Text className='pTag'>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button variant="primary"><Link className='linkStyle' to="/projectdetails"> View More </Link></Button>
      </Card.Body>
    </Card>
                </Col>
                <Col lg={4} md={6} sm={12}>
                   <Card className='projectCard'>
      <Card.Img variant="top" src={hall3D} />
      <Card.Body>
        <Card.Title className='h2Tag'>project 2</Card.Title>
        <Card.Text className='pTag'>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button variant="primary"><Link className='linkStyle' to="/projectdetails"> View More </Link></Button>
      </Card.Body>
    </Card>
                </Col>
            </Row>

        </Container>

      </Fragment>
      
    )
  }
}

export default AllProjects
